import {
  APPOINTMENT_RESOURCE_OPTIONS,
  BILLING_PROVIDER_OPTIONS,
  PATIENT_OPTIONS,
  PAYER_OPTIONS,
  PROVIDER_CLAIM_OPTIONS,
  SUPERBILL_OPTIONS
} from 'components/shared/Filters/lib/filterOptions';

import { SUPERBILL_SWITCH_ITEMS } from './superbillTableColumns';

export default {
  date: {
    type: 'date-range',
    title: 'Date of service',
    icon: 'calendar-mono'
  },
  superbill_id: SUPERBILL_OPTIONS,
  patient: PATIENT_OPTIONS,
  provider: PROVIDER_CLAIM_OPTIONS,
  payer: PAYER_OPTIONS,
  appointment_resource: APPOINTMENT_RESOURCE_OPTIONS,
  billing_provider: BILLING_PROVIDER_OPTIONS,
  status: {
    title: 'Status',
    multiple: true,
    queryFn: (_, data) => {
      const searchTerm = data.filters.searchTerm || '';
      return {
        options: SUPERBILL_SWITCH_ITEMS.filter((status) =>
          status.label.toLowerCase().includes(searchTerm.toLowerCase())
        )
      };
    },
    queryKey: 'superbill_status.options',
    icon: 'status-mono',
    allowed_operators: ['is any of', 'is not', 'is']
  }
};
